import { HttpService } from "./HttpService";
import { StorageService } from "./StorageService";
import { TokenService } from "./TokenService";

export const storageService = new StorageService();
export const httpService = new HttpService();
export const tokenService = new TokenService();